import React,{useState} from 'react'
import './nav.css'
import {GoHome} from 'react-icons/go'
import {FaUserSecret,FaBookDead} from 'react-icons/fa'
import {RiHeartPulseLine} from 'react-icons/ri'
import {MdOutlineContacts} from 'react-icons/md'

function Nav() {
  const [activeNav,setActiveNav] =useState('#home')
  return (
    <nav>
      <a href="#home"  onClick={()=>setActiveNav('#home')} className={activeNav === '#home' ? 'active' : ''}><GoHome/></a>
      <a href="#about" onClick={()=>setActiveNav('#about')} className={activeNav === '#about' ? 'active' : ''}><FaUserSecret/></a>
      <a href="#experience" onClick={()=>setActiveNav('#experience')} className={activeNav === '#experience' ? 'active' : ''}><FaBookDead/></a>
      <a href="#services" onClick={()=>setActiveNav('#services')} className={activeNav === '#services' ? 'active' : ''}><RiHeartPulseLine/></a>
      <a href="#contact" onClick={()=>setActiveNav('#contact')} className={activeNav === '#contact' ? 'active' : ''}><MdOutlineContacts/></a>
    </nav>
  )
}

export default Nav